import { omit } from '@shared/utils';

import type { QuestionCreationTask, Task } from '../../types';

import { DEFAULT_QUESTION_CREATION_TASK_DETAILS } from './constants';

export function mapTaskToQuestionCreationTask(task: Task | undefined) {
  if (!task) {
    return DEFAULT_QUESTION_CREATION_TASK_DETAILS;
  }
  const taskMetadata =
    task.metadata.__typename === 'TaskMetadataWithQuestionCreation' ? task.metadata : null;

  return {
    ...omit(task, 'metadata'),
    dueDate: task.dueDate ? new Date(task.dueDate) : new Date(),
    metadata: { requirement: taskMetadata },
  } as QuestionCreationTask;
}
